import { FC, useState } from "react";
import { DialogData, DialogHandle } from "../../types";
import { _, calcMaxChildren, getZoneName, parseNum } from "../../utils/helpers";
import { CHILDREN_PER_ADULT, CHILDREN_ZONES, DEFAULT_DIALOG_HANDLE, translator } from "../../utils/symbols";
import { SafeImage } from "../../parts/SafeImage";
import { Icon } from "../../parts/Icon";
import { useApp } from "../../context/useApp";
import Lottie from "lottie-react";
import * as instructionsLottie from '../../resources/lotties/children-instructions.json'
import { AddButton } from "../../parts/inputs/AddButton";

interface CamDialogProps {
    dialogData: DialogData
}

export const CamDialog: FC<CamDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles, booking }
    } = useApp()

    if (dialogData.dialog !== 'cam') return null
    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const name = (() => {
        let x = translator.getProcessedTranslation(dialogData.name)
        if (x === dialogData.name) x = translator.getProcessedTranslation(dialogData.name)
        return x
    })()

    return (
        <section 
            className={`df fd-c aic jcc r3 section p-r `}
            aria-labelledby="dialog-label"
            aria-describedby="dialog-description"
        >   
            <SafeImage src={dialogData.img} className="r3 w-100 mb-9"/>       
            <p className="text s24-600 white center mb-6">{name}</p>
            <div className="df aic jcc">
            { dialogData.zones.map(zone => <p key={zone} className={`text s18-500 p-5 cap white w-fc zone-name r3 zone-${zone}`}>{`${getZoneName('long',zone,booking.journey)}`}</p>)}
            </div>
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc mt-0"
                onClick={() => dialogHandle.closeDialog()}
            >
                <Icon icon="close"/>
            </button>
        </section>
    )
}